<template>
  <div class="service">
    <div class="borderColordarkgray2 rounded overflow-hidden">
      <div class="service py-4 lg:py-6" v-if="questionType">
        <h3 class="text-NotoSansBold font-bold text-base lg:text-lg text title mb-6 lg:mb-10 px-4 md:px-8">
          {{ questionType.title }}
        </h3>

        <div class="privacy-body">

          <div class="wrapper mx-auto w-full">
            <div class="wrap border-t border-b border-white" v-for="(item, index) in questionType.questions" :key="index">
              <input type="radio" :id="'tab-' + index" name="tabs" class="hidden"
                @click="toggle(index)" :class="{ showContent: index === idx }">
              <label :for="'tab-' + index" class="label flex w-full cursor-pointer">
                <div class="text-NotoSansBold textColorBlack py-2 md:py-3">
                  <h5 class="m-0 text-base leading-relaxed question tracking-wider">Q{{ index + 1 }}：{{ item.question }}</h5>
                </div>
                <div class="cross mx-3 flex items-center">
                  <font-awesome-icon icon="plus" class="text-white text-xl" v-if="index !== idx" />
                  <font-awesome-icon icon="minus" class="text-white text-xl" v-else />
                  <!-- <img class="w-full h-full object-contain" src="~@/assets/icon/bt_plus.png" alt="livaABC"> -->
                </div>
              </label>

              <div class="content text-NotoSansRegular px-4 lg:px-6 leading-normal textColorBlack box-border overflow-hidden border-l border-r border-b">
                <div class="m-0 text-base tracking-wider" v-html="item.answer"></div>

                <iframe width="560" height="315" :src="item.url" v-if="item.url"
                  frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen>
                </iframe>

                <table class="table-auto text-center text-NotoSansRegular w-full mt-4" v-if="item.table">
                  <thead>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in item.table" :key="key">
                      <td class="border px-1 lg:px-4 py-2 borderColordarkgray" v-html="item.name1" v-if="item.name1"></td>
                      <td class="border px-1 lg:px-4 py-2 borderColordarkgray" v-html="item.name2" v-if="item.name2"></td>
                      <td class="border px-1 lg:px-4 py-2 borderColordarkgray" v-html="item.name3" v-if="item.name3"></td>
                      <td class="border px-1 lg:px-4 py-2 borderColordarkgray" v-html="item.name4" v-if="item.name4"></td>
                      <td class="border px-1 lg:px-4 py-2 borderColordarkgray" v-html="item.name5" v-if="item.name5"></td>
                    </tr>
                  </tbody>
                </table>
                <table class="table-auto text-center text-NotoSansRegular w-full mt-4 whitespace-pre-wrap" v-if="item.table">
                  <thead>
                  </thead>
                  <tbody class="border px-1 lg:px-4 py-2 borderColordarkgray">
                    <tr class="border">
                      <td class="border px-1 lg:px-4 py-2 borderColordarkgray whitespace-no-wrap">載具</td>
                      <td class="border px-1 lg:px-4 py-2 borderColordarkgray whitespace-no-wrap">狀態</td>
                      <td class="border px-1 lg:px-4 py-2 borderColordarkgray">中獎通知單位</td>
                      <td colspan="3" class="border px-1 lg:px-4 py-2 borderColordarkgray">領取中獎發票</td>
                    </tr>
                    <tr class="border">
                      <td rowspan="2" class="border px-1 lg:px-4 py-2 borderColordarkgray">手機條碼載具<br/><br/>自然人憑證載具</td>
                      <td rowspan="2" class="border px-1 lg:px-4 py-2 borderColordarkgray">已歸戶</td>
                      <td rowspan="2" class="border px-1 lg:px-4 py-2 borderColordarkgray whitespace-pre-wrap">
                        <span class="whitespace-pre-wrap"><a href="https://www.einvoice.nat.gov.tw/index" class="underline">財政部電子發票整合服務平台</a>依據您留存之電子郵件及手機簡訊通知中獎。<br/>亦可至<a href="https://www.einvoice.nat.gov.tw/index" class="underline">財政部電子發票整合服務平台</a>或使用超商多媒體服務機查詢。
                          </span></td>
                      <td class="border px-1 lg:px-4 py-2 borderColordarkgray">已設定<br/>領獎帳戶</td>
                      <td class="border px-1 py-2 borderColordarkgray">></td>
                      <td class="border px-1 lg:px-4 py-2 borderColordarkgray">獎金將於開獎次月 6 號直接匯入歸戶指定帳號中（扣除應繳納稅額）。</td>
                    </tr>
                    <tr class="border">
                      <td class="border px-1 lg:px-4 py-2 borderColordarkgray">亦可至<a href="https://www.einvoice.nat.gov.tw/index" class="underline">財政部電子發票整合服務平台</a>或使用超商多媒體服務機查詢</td>
                      <td class="border px-1 py-2 borderColordarkgray">></td>
                      <td class="border px-1 lg:px-4 py-2 borderColordarkgray">中獎人可至<a href="https://www.einvoice.nat.gov.tw/index" class="underline">財政部電子發票整合服務平台</a>或超商多媒體服務機列印紙本發票向郵局兌獎。</td>
                    </tr>
                    <tr class="border">
                      <td class="border px-1 lg:px-4 py-2 borderColordarkgray">會員載具</td>
                      <td class="border px-1 lg:px-4 py-2 borderColordarkgray">未歸戶</td>
                      <td class="border px-1 lg:px-4 py-2 borderColordarkgray">本公司將依<a href="https://www.einvoice.nat.gov.tw/index" class="underline">財政部電子發票整合服務平台</a>所提供之中獎清冊，自動幫您核對是否中獎，若有中獎將以E-mail通知。</td>
                      <td colspan="3" class="border px-1 lg:px-4 py-2 borderColordarkgray">本公司將於對獎後，將中獎發票以掛號方式郵寄至您的訂單地址</td>
                    </tr>
                  </tbody>
                </table>
                <p v-if="item.quote" class="mt-2">{{ item.quote }}</p>
                <div v-if="item.images" class="flex flex-wrap items-start">
                  <div v-for="(child, idx) in item.images" :key="idx" class="">
                    <p class="mb-4 text-center">{{ child.title }}</p>
                    <a :href="require(`@/assets/images/company/${child.file}`)" target="_blank" class="block">
                      <img :src="require(`@/assets/images/company/${child.file}`)" class="cursor-pointer object-contain w-full max-w-full">
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import json from '@/components/modules/serviceQA.json'
export default {
  name: 'Service',
  metaInfo () {
    return {
      title: '常見QA-' + this.questionType.title,
      titleTemplate: null
    }
  },
  data () {
    return {
      QAdata: json,
      idx: null,

      coverImage: [],
      coverIdx: null
    }
  },
  components: {
  },
  watch: {
    '$route.params': {
      handler (newVal, oldVal) {
        if ((newVal !== oldVal)) {
          // this.idx = null
          this.idx = 0
        }
      }
    }
  },
  computed: {
    questionType () {
      let self = this
      let index = self.QAdata.data.findIndex(x => x.name === self.$route.params.id)
      return self.QAdata.data[index]
    }
  },
  mounted () {
    this.toggle(0)
  },
  updated () {
  },
  methods: {
    toggle (index) {
      let self = this
      if (self.idx === index) {
        // self.idx = null
        self.idx = 0
      } else {
        self.idx = index
      }
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.cursor-zoom {
  cursor:zoom-in;
}
table tbody tr:first-child {
  font-weight: 900;
  color: #2C3E50 !important;
}
.label {
  border: 3px solid #c7c7c7;
  user-select: none;
  background-color: #c7c7c7;
}
.label div:first-child {
  width: 100%;
  margin-left: 10px;
  font-size: 1.2em;
}
.content {
  font-size: 0.9em;
  max-height: 0;
  transition: .4s;
}
.showContent ~ .content {
  height: 100%;
  max-height: 100%;
  transition: .4s;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
</style>
